<p-dialog [(visible)]="visible" [modal]="true" (onHide)="onHideDataDialog()">
  <ami-table-actions
  [settings]="tableDetailSettings"
  [data]="detailsResponse"
  >
  </ami-table-actions>
</p-dialog>